import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import type { OverviewFilters, TopicExampleRow } from "@nexus/contracts";
import {
  flattenExampleBatches,
  topicDetailExamplesInfiniteQueryOptions,
} from "@/lib/queries/overview.queries";
import type { MyBrandFiltersInput } from "@/lib/queries/dashboard.queries";
import type { TopicDetailContext } from "../lib/topicDetailContext.js";

export function useTopicDetailExamples(
  tenantId: string,
  overviewFilters: OverviewFilters,
  globalFilters: MyBrandFiltersInput,
  context: TopicDetailContext | null,
) {
  const query = useInfiniteQuery({
    ...topicDetailExamplesInfiniteQueryOptions(tenantId, overviewFilters, globalFilters, context),
    enabled: !!tenantId && !!context,
  });

  const rows = useMemo(
    () => flattenExampleBatches<TopicExampleRow>(query.data?.pages),
    [query.data?.pages],
  );

  return {
    rows,
    isLoading: query.isLoading,
    isError: query.isError,
    fetchNextPage: query.fetchNextPage,
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    isFetchNextPageError: query.isFetchNextPageError,
  };
}
